import {graphql, compose} from 'react-apollo';
import gql from 'graphql-tag';

import {Content, Snippet} from '../qql-shared/fragments';
import {
  DeleteContentMutation,
  DeleteContentMutationConfig,
  SaveContentMutation,
  SaveContentMutationConfig,
} from '../qql-shared/mutations';
import ContentForm from '../components/ContentForm';
import config from '../config';

const ContentQuery = gql`
  query content($_id: String!, $project: String!) {
    content(_id: $_id) {
      ...Content
    }
    allSnippets(project: $project) {
      ...Snippet
    }
  }
  ${Content}
  ${Snippet}
`;

const ContentQueryConfig = {
  options: ({match}) => ({
    variables: {_id: match.params.id, project: config.getProjectKey()},
    fetchPolicy: 'network-only',
  }),
};

export default compose(
  graphql(SaveContentMutation, SaveContentMutationConfig),
  graphql(DeleteContentMutation, DeleteContentMutationConfig),
  graphql(ContentQuery, ContentQueryConfig)
)(ContentForm);



// WEBPACK FOOTER //
// ./src/containers/ContentEdit.js